import { SvgIconComponent } from '@ngneat/svg-icon';
import { Component, Input, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { ProductNotAllowed } from '../../../services/order.service';
import { iconCloseIcon } from '@svg/icon-close';
import { registerSvgIcons } from '@shared/utils/svg-icons';



@Component({
  selector: 'app-product-retired',
  templateUrl: './product-retired.component.html',
  styleUrls: ['./product-retired.component.scss'],
  standalone: true,
  imports: [
    SvgIconComponent,
    CommonModule,
    TranslateModule,
    ],
})
export class ProductRetiredComponent {
  private readonly activeModal = inject(NgbActiveModal);

  @Input() productsRetired: ProductNotAllowed[];

  constructor() {
    registerSvgIcons(iconCloseIcon);
  }


  close() {
    this.activeModal.close();
  }
}
